import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { Params } from "../../../types/Types";
import { CompanyProfileData } from "../../../components/Models/CompanyProfileData";

interface PaginatedCompanyResponse {
  companies: CompanyProfileData[];
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
}

export function useGetActiveCompanies({
  enabled = true,
  pageSize = 10,
  page = 1,
}: Params = {}) {
  return useQuery({
    enabled,
    queryKey: ["companies", { pageSize, page }],
    queryFn: async () => {
      const url = getAPIURL(
        `/MuslimInvestProfile/Company/Active?pageNumber=${page}&pageSize=${pageSize}`
      );
      return axiosInstance<PaginatedCompanyResponse>(url).then(
        (res) => res.data
      );
    },
  });
}
